import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";
import lang from "../../lib/appfuse-react/core/lang";
import Sort from "../../lib/appfuse-react/core/Sort";


const name="marketTestPlan";

const initialState = {
    data:[],
    selection: [],
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    nodeId:null
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = action.payload;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setSort(state, action) {
            state.sort = action.payload;
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setNodeId(state, action) {
            state.nodeId=action.payload;
        }
    }
});

export const { setSelection, setPageNumber, setPageSize, setData, setCriteria, setDrafts, setNodeId, setSort } = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectSelection = state => state[name].selection;
export const selectSort = state => {
    const jsonObject = state[name].sort;
    if(lang.isNullOrUndefined(jsonObject)) return new Sort();

    const sort = json.fromJSON(jsonObject, Sort);
    return sort;
}

export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectCriteria = state => state[name].criteria;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectDraft = (key) => (state) => selectDrafts(state)[key];
export const selectNodeId = state => state[name].nodeId;

export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const marketTestPlanReducer = reducer;
export default marketTestPlanReducer;